<script>
    import {
        Spinner, Table, Icon, Input, Button, Offcanvas,
        Modal, ModalBody, ModalFooter, ModalHeader
    } from 'sveltestrap';
    import SortCaret from './SortCaret.svelte';
    import MediaDuration from './MediaDuration.svelte';
    import MediaDate from './MediaDate.svelte';
    import MediaDetails from './MediaDetails.svelte';
    import BlockAdd from './BlockAdd.svelte';

    export let server;
    export let token = undefined;
    export let login;
    export let password;
    export let haveBlocks;

    let retryMedia = 1;
    let retryBlocks = 1;
    let retryAll = 1;
    let order = "nameci";
    let direction = "asc";
    let search = {};
    let nameciSearch = "";
    let dirciSearch = "";
    let smartMediaPromise;
    let groupPromise;
    let checked = {};
    let savedMedia = {};
    let allMedia = {};
    let savedBlocks = [];
    let offcanvasMedia = undefined;
    let deleteLength = 0;
    let openDeleteModal = false;

	async function getMediaList(arg, retry) {
        const response = await fetch(server + "/rest/media?" +
            new URLSearchParams(arg), {
                method: 'GET',
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': "Bearer " + token
                }
		});
		const json = await response.json();

		if (response.ok) {
            savedMedia = {};
            json.forEach(element => savedMedia[element.media_id] = element);
			return json;
		} else {
			throw new Error(response.status);
		}
	}

    async function getBlockList(retry) {
        const response = await fetch(server + "/rest/media?block=not.is.null&select=media_id,name,block", {
                method: 'GET',
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': "Bearer " + token
                }
		});
		const json = await response.json();

		if (response.ok) {
            savedBlocks = json;
			return json;
		} else {
			throw new Error(response.status);
		}
    }

	async function getAllList(retry) {
        const response = await fetch(server + "/rest/media", {
                method: 'GET',
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': "Bearer " + token
                }
		});
		const json = await response.json();

		if (response.ok) {
            allMedia = {};
            json.forEach(element => allMedia[element.media_id] = element);
			return json;
		} else {
			throw new Error(response.status);
		}
	}

    function uncheckAll() {
        for (var i in checked)
            checked[i] = "secondary";
    }

    function checkAll(event) {
        event.preventDefault();
        let allChecked = true;
        for (var i in checked) {
            if (checked[i] != "success")
                allChecked = false;
            checked[i] = "success";
        }

        if (allChecked)
            uncheckAll();
    }

    function getChecked() {
        let list = Array();
        for (var i in checked)
            if (checked[i] == "success")
                list.push(i);
        return list;
    }

    async function insertMediaDB(obj) {
        const response = await fetch(server + "/rest/media", {
                method: 'POST',
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': "Bearer " + token,
                    'Content-Type': 'application/json;charset=utf-8',
                    'Prefer': 'return=representation'
                },
                body: JSON.stringify(obj)
		});
		const json = await response.json();

		if (response.ok) {
            uncheckAll();
            offcanvasMedia = json[0];
            retryMedia++;
            retryAll++;
            if (obj.block)
                retryBlocks++;
		} else {
			throw new Error(response.status);
		}
    }

    async function deleteMediaDB(arg) {
        const response = await fetch(server + "/rest/media?" +
            new URLSearchParams(arg), {
                method: 'DELETE',
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': "Bearer " + token
                }
		});

		if (response.ok) {
            offcanvasMedia = undefined;
            retryMedia++;
            retryBlocks++;
            retryAll++;
		} else {
			throw new Error(response.status);
		}
    }

    async function patchMediaDB(obj) {
        const response = await fetch(server + "/rest/media?media_id=eq." + obj.media_id, {
                method: 'PATCH',
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Authorization': "Bearer " + token,
                    'Content-Type': 'application/json;charset=utf-8',
                    'Prefer': 'return=representation'
                },
                body: JSON.stringify(obj)
		});
		const json = await response.json();

		if (response.ok) {
            uncheckAll();
            offcanvasMedia = json[0];
            retryMedia++;
            retryAll++;
            if (obj.block)
                retryBlocks++;
		} else {
			throw new Error(response.status);
		}
    }

    function saveBlockMedia(event) {
        let list = getChecked();
        if (!list.length)
            return;

        groupPromise = insertMediaDB({
            'name': "Block " + list.join(","),
            'dir': "Block media",
            'block': list
        });
    }

    function deleteMedia(event) {
        openDeleteModal = false;
        let list = getChecked();
        if (!list.length)
            return;

        groupPromise = deleteMediaDB({
            'media_id': "in.(" + list.join(",") + ")"
        });
        for (const i of list) {
            delete savedMedia[i];
            delete allMedia[i];
            delete checked[i];
        }
    }

    function deleteMediaConfirm(event) {
        let list = getChecked();
        deleteLength = list.length;
        if (!deleteLength)
            return;

        openDeleteModal = true;
    }

    function toggleDeleteModal() {
        openDeleteModal = !openDeleteModal;
    }

    function setOrder(event) {
        let column = event.target.dataset.sort;
        if (!column)
            column = "nameci";
        if (column == order)
            direction = (direction == "asc" ? "desc" : "asc");
        order = column;
    }

    function handleSearch(event) {
        search = {};
        if (nameciSearch)
            search.nameci = "like.%" + nameciSearch + "%";
        if (dirciSearch)
            search.dirci = "like.%" + dirciSearch + "%";
    }

    function saveSmartMedia(event) {
        handleSearch(event);
        if (!nameciSearch && !dirciSearch) {
            alert("No filter configured.");
            return;
        }
        let smart = "Smart";
        if (nameciSearch)
            smart += " name: " + nameciSearch;
        if (dirciSearch)
            smart += " dir: " + dirciSearch;
        smartMediaPromise = insertMediaDB({
            'name': smart,
            'dir': "Smart media",
            'smart': JSON.stringify(search)
        });
    }

    function selectMedia(event) {
        let mediaId = event.target.closest("tr").dataset.mediaId;
        if (checked[mediaId] == "success") {
            checked[mediaId] = "secondary";
            offcanvasMedia = undefined;
            return;
        } else {
            checked[mediaId] = "success";
        }
        for (var i in checked) {
            if (i != mediaId && checked[i] == "success") {
                offcanvasMedia = undefined;
                return;
            }
        }
        offcanvasMedia = { ...savedMedia[mediaId] };
    }

    function patchMedia(event) {
        const media = event.detail;
        groupPromise = patchMediaDB(media);
    }

    function toggleMedia(event) {
        event.stopPropagation();
        event.preventDefault();
        let mediaId = event.target.closest("tr").dataset.mediaId;
        if (checked[mediaId] == "success") {
            checked[mediaId] = "secondary";
        } else {
            checked[mediaId] = "success";
        }
    }

    function offcanvasToggle(event) {
        checked[offcanvasMedia.media_id] = "secondary";
        offcanvasMedia = undefined;
    }

    $: mediaPromise = getMediaList({
        order: order + "." + direction,
        ...search
    }, retryMedia);
    $: getBlockList(retryBlocks);
    $: getAllList(retryAll);
    $: hasFilter = nameciSearch.length + dirciSearch.length > 0;
    $: hasChecked = Object.values(checked).indexOf("success") > -1;
    document.title = "[" + login + "] Media list";
</script>

<div class="mediaList">
    {#await mediaPromise}
        <div class="text-center"><Spinner primary size="bg" /></div>
    {:then mediaList}
        <form on:submit|preventDefault={handleSearch}>
            <p>Group actions on selected media:
                {#await groupPromise}
                    <Spinner primary size="sm" />
                {:then junk}
                    {#if haveBlocks}
                        <Button type="button" color="primary" disabled={!hasChecked} on:click={saveBlockMedia}>
                            <Icon name="folder-plus" /> Create block media
                        </Button>
                        <BlockAdd {checked} disabled={!hasChecked} {savedBlocks} on:patch={patchMedia} />
                    {/if}
                    <Button type="button" color="danger" disabled={!hasChecked} on:click={deleteMediaConfirm}>
                        <Icon name="trash-fill" /> Delete
                    </Button>
                {:catch error}
                    {#if haveBlocks}
                        <Button type="button" color="primary" disabled={!hasChecked} on:click={saveBlockMedia}>
                            <Icon name="folder-plus" /> Create block media
                        </Button>
                        <BlockAdd {checked} disabled={!hasChecked} {savedBlocks} on:patch={patchMedia} />
                    {/if}
                    <Button type="button" color="danger" disabled={!hasChecked} on:click={deleteMediaConfirm}>
                        <Icon name="trash-fill" /> Delete
                    </Button>
                    <p class="error">Error: {error}</p>
                {/await}
            </p>
            <Table striped>
                <thead>
                    <tr on:click={setOrder}>
                        <th></th>
                        <th data-sort="nameci" class="order">Name <SortCaret name="nameci" {order} {direction} /></th>
                        <th data-sort="dirci" class="order">Directory <SortCaret name="dirci" {order} {direction} /></th>
                        <th data-sort="creation" class="order">Creation <SortCaret name="creation" {order} {direction} /></th>
                        <th data-sort="duration" class="order">Duration <SortCaret name="duration" {order} {direction} /></th>
                    </tr>
                    <tr>
                        <th><Button type="button" on:click={checkAll}><Icon name="check-all" /></Button></th>
                        <th><Input type="search" bind:value={nameciSearch} name="nameciSearch" placeholder="filter by name" /></th>
                        <th><Input type="search" bind:value={dirciSearch} name="dirciSearch" placeholder="filter by directory" /></th>
                        <th colspan="2">
                            <Button type="submit"><Icon name="filter-square-fill" /> Filter rows</Button>
                            {#if haveBlocks}
                                {#await smartMediaPromise}
                                    <Spinner primary size="sm" />
                                {:then junk}
                                    <Button type="button" color="primary" disabled={!hasFilter} on:click={saveSmartMedia}>
                                        <Icon name="bookmark-plus-fill" /> Create smart media
                                    </Button>
                                {:catch error}
                                    <Button type="button" color="primary" disabled={!hasFilter} on:click={saveSmartMedia}>
                                        <Icon name="bookmark-plus-fill" /> Create smart media
                                    </Button>
                                    <p class="error">Error: {error}</p>
                                {/await}
                            {/if}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {#each mediaList as media}
                        <tr data-media-id={media.media_id} on:click={selectMedia}>
                            <th><Button type="button" bind:color={checked[media.media_id]} size="sm" on:click={toggleMedia}><Icon name="check" /></Button></th>
                            <td>{media.name}</td>
                            {#if media.smart}
                                <td class="info">Smart media</td>
                            {:else if media.block}
                                <td class="info">Block media</td>
                            {:else}
                                <td>{media.dir}</td>
                            {/if}
                            <td><MediaDate date={media.creation} /></td>
                            {#if media.smart || media.block}
                                <td></td>
                            {:else}
                                <td><MediaDuration duration={media.duration} /></td>
                            {/if}
                        </tr>
                    {/each}
                </tbody>
            </Table>
        </form>

        {#if offcanvasMedia}
            <Offcanvas isOpen={true} toggle={offcanvasToggle} placement="end" header={offcanvasMedia.name}>
                <MediaDetails {server} {token} {login} {password} {haveBlocks} {savedBlocks} media={offcanvasMedia} allMedia={allMedia} on:patch={patchMedia} on:delete={deleteMediaConfirm} />
            </Offcanvas>
        {:else}
            <Offcanvas isOpen={false} placement="end" />
        {/if}
    {:catch error}
        <p class="error">Unable to download media list: {error.message}</p>
    {/await}

    <Modal isOpen={openDeleteModal} toggle={toggleDeleteModal}>
        <ModalHeader toggle={toggleDeleteModal}>Warning</ModalHeader>
        <ModalBody>
            Deleting media will delete the content itself. Resurrection is impossible. {deleteLength} media will be deleted.
            Do you confirm?
        </ModalBody>
        <ModalFooter>
            <Button color="primary" on:click={toggleDeleteModal}>Cancel</Button>
            <Button color="secondary" on:click={deleteMedia}>Confirm</Button>
        </ModalFooter>
    </Modal>
</div>

<style>
    .mediaList {
        width: 100%;
        height: 100%;
	}
    .error {
        margin-top: 1em;
        font-weight: bold;
        color: red;
    }
    .info {
        font-style: italic;
    }
    thead {
        position: sticky;
        top: 0;
        background: white;
    }
    .order {
        cursor: pointer;
    }
</style>